<div class="modal-content m-0">
  <div class="modal-header">
    <p class="mb-0">{{ 'sample.replaceKitDialog.title' | translate }}</p>
    <i class="fa-light fa-xmark ms-auto cursor-pointer" (click)="dismiss()"></i>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-12">
        @if (sample$ | async; as sample) {
          {{
            'sample.replaceKitDialog.description'
              | translate: { kitId: sample.kitId }
          }}
        }

        @if (kits$ | async; as kits) {
          <app-select
            id="kitId"
            data-cy="kit-select"
            class="mt-4"
            [formControl]="kitFormControl"
            [placeholder]="
              kits.length
                ? ('sample.form.placeholders.selectKit' | translate)
                : ('sample.form.placeholders.noKitsAvailable' | translate)
            "
          >
            @for (kit of kits; track kit?.id) {
              <app-select-option
                [value]="kit?.id"
                [label]="kit.id"
              />
            }
          </app-select>
        } @else {
          <div class="loading"></div>
        }
      </div>
      <div class="col-12 d-flex flex-row-reverse mt-3">
        <button
          class="btn btn-primary"
          [disabled]="kitFormControl.invalid || loading"
          [class.loading]="loading"
          (click)="submit()"
        >
          {{ 'sample.replaceKitDialog.button' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
